import VueRouter from 'vue-router'
// import {SecureGuard} from "./guards/AuthenticationGuard";
//
import Life from './components/pages/sub_category/templates/Life'
import SubLife from './components/pages/sub_category/templates/SubLife'
import Inspector from './components/pages/sub_category/browse/Inspector'
import Profil from './components/pages/category/Profil'
import Notifications from './components/pages/category/Notifications'
//
import ChallengesMessagerie from './components/pages/sub_category/challenges/ChallengesMessagerie'
import ChallengesMessagerieContact from './components/pages/sub_category/challenges/ChallengesMessagerieContact'
//

export const router = new VueRouter({
    mode: 'history',
    routes: [
      { path: "*", 
      component: () =>
      import(/* webpackChunkName: "404" */ "@/components/pages/404"),
      },
      { 
        path: "/", 
        name: "home",
        redirect: "/admin/me/resume" 
      },      
      { 
        path: "/admin", 
        redirect: "/admin/me/resume" 
      },      
      { 
        path: "/home", 
        redirect: "/admin/me/resume" 
      },
      // {
      //   path: "/auth/login",
      //   name: "login",
      //   component: () =>
      //       import(/* webpackChunkName: "login" */ "@/components/pages/LoginPage"),
      // },
      {
        path: "/admin/:connected?",
        name: "admin",
        // beforeEnter : SecureGuard,
        component: () =>
          import(/* webpackChunkName: "admin" */ "@/components/pages/Admin"),
          children:[
            {
              path: "profile",
              components:{
                slideOut:Profil,
              }, 
              children:[
                {
                  path: "/",
                  name: "profileHome",
                  // name: "profil",
                  component: () =>
                  import(/* webpackChunkName: "profileHome" */ "@/components/pages/sub_category/profile/ProfileHome"),   
                  meta: { 
                    bodyClass: 'profile', 
                  }, 
                  children:[
                    {
                      path: "info",
                      name: "profileInfo",
                      component: () =>
                      import(/* webpackChunkName: "ProfileInfo" */ "@/components/pages/sub_category/profile/ProfileInfo"),   
                      meta: { 
                        bodyClass: 'profile', 
                      },                               
                    },
                    {
                      path: "collaborateur",
                      name: "profileCollab",
                      component: () =>
                      import(/* webpackChunkName: "ProfileCollab" */ "@/components/pages/sub_category/profile/ProfileCollab"),   
                      meta: { 
                        bodyClass: 'profile', 
                      }, 
                      children:[
                        {
                          path: "ajouter",
                          name: "profileCollabAdd",
                          component: () =>
                          // import(/* webpackChunkName: "FormCollab" */ "@/components/pages/sub_category/profile/FormCollab"),   
                          import(/* webpackChunkName: "FormCollab" */ "@/components/module/modal/FormCollab"),   
                          meta: { 
                            bodyClass: 'profile', 
                          },                            
                        }
                      ]
                    },
                    {
                      path: "notifications",
                      name: "profileNotification",
                      component: () =>
                      import(/* webpackChunkName: "ProfileNotifications" */ "@/components/pages/sub_category/profile/ProfileNotifications"),   
                      meta: { 
                        bodyClass: 'profile', 
                      },                               
                    },
                  ]                                                  
                },
              ]                    
            }, 
            {
              path: "notifications",
              components:{
                slideOut:Notifications,
              },  
              children:[
                {
                  path: "/",
                  name: "notificationsHome",
                  component: () =>
                  import(/* webpackChunkName: "notificationsHome" */ "@/components/pages/sub_category/notifications/NotificationsHome"),   
                  meta: { 
                    bodyClass: 'notifications', 
                  },                                                 
                },
              ]                    
            },                           
            {
              path: "parcourir",
              // name: "browse",
              // beforeEnter : SecureGuard,
              meta: { 
                bodyClass: 'browse' 
              },
              component: () =>
              import(/* webpackChunkName: "browse" */ "@/components/pages/category/Browse"),
              children:[
                {
                  path: "/",
                  name: "browseHome",
                  component: () =>
                  import(/* webpackChunkName: "browseHome" */ "@/components/pages/sub_category/browse/BrowseHome"),   
                  meta: { 
                    bodyClass: 'browse', 
                  },  
                  children:[
                    {
                      path: "vie/:cat/:who/",
                      name: "life",
                      meta: {bodyClass: 'browse'},                     
                      components:{
                        default:Life,
                      }, 
                    },
                    {
                      path: "vie/:cat/:who/sub/:id/",
                      name: "subLife",
                      components:{
                        default:Life,
                        helper: SubLife
                      },                                                                                           
                    },  
                    {
                      path: "vie/:cat/:who/sub/:id/:subId/",
                      name: "inspector",
                      components:{
                        default:Life,
                        helper: Inspector
                      },   
                    },                        
                    {
                      path: "vie/:cat/:who/sub/:id/:subId/:profil",
                      name: "profil",
                      components:{
                        default:Life,
                        helper: Profil
                      },                                                            
                    },                                          
                  ]                             
                },

                {
                  path: "dommages/:name",
                  name: "damage",
                  component: () =>
                  import(/* webpackChunkName: "damage" */ "@/components/pages/sub_category/templates/Damage"), 
                  meta: { 
                    bodyClass: 'browse',
                  },                                 
                },
                {
                  path: "qualite/:link",
                  name: "quality",
                  component: () =>
                  import(/* webpackChunkName: "quality" */ "@/components/pages/sub_category/templates/Quality"),
                  meta: { 
                    bodyClass: 'browse',
                  },                               
                }
              ]
            },
            {
              path: "resume/",
              component: () =>
                  import(/* webpackChunkName: "resume" */ "@/components/pages/category/Resume"),
                  children:[
                    {
                      path: "/",
                      name: "resumeHome",
                      component: () =>
                      import(/* webpackChunkName: "resumeHome" */ "@/components/pages/sub_category/resume/ResumeHome"),   
                      meta: { 
                        bodyClass: 'resume', 
                      },                               
                    },
                  ]                    
            },         
            {
              path: "challenges/",
              component: () =>
                  import(/* webpackChunkName: "challenges" */ "@/components/pages/category/Challenges"),
                  children:[
                    {
                      path: "/",
                      name: "challengesHome",
                      component: () =>
                      import(/* webpackChunkName: "challengesHome" */ "@/components/pages/sub_category/challenges/ChallengesHome"),   
                      meta: { 
                        bodyClass: 'challenges', 
                      },
                      children:[
                        {
                          path: "messagerie/",
                          name: "challenges-messagerie",
                          meta: {bodyClass: 'challenges'},
                          components:{
                            default: ChallengesMessagerie
                          },   
                          children:[
                            {
                              path: "contact",
                              name: "challenges-messgerie-contact",
                              meta: {bodyClass: 'challenges'},
                              components:{
                                helper: ChallengesMessagerieContact
                              },
                            }                              
                          ]                                    
                        },
                        {
                          path: "accueil",
                          name: "challenges-accueil",
                          component: () =>
                          import(/* webpackChunkName: "challengesAccueil" */ "@/components/pages/sub_category/challenges/ChallengesAccueil"),   
                          meta: { 
                            bodyClass: 'challenges', 
                          }                           
                        },
                        {
                          path: "excursions",
                          name: "challenges-excursions",
                          component: () =>
                          import(/* webpackChunkName: "challengesExcursions" */ "@/components/pages/sub_category/challenges/ChallengesExcursions"),   
                          meta: { 
                            bodyClass: 'challenges', 
                          }                           
                        },
                        {
                          path: "challenges-commerciaux",
                          name: "challenges-commerciaux",
                          component: () =>
                          import(/* webpackChunkName: "challengesCommerciaux" */ "@/components/pages/sub_category/challenges/ChallengesCommerciaux"),   
                          meta: { 
                            bodyClass: 'challenges', 
                          }                           
                        },
                        {
                          path: "boutique",
                          name: "challenges-boutique",
                          component: () =>
                          import(/* webpackChunkName: "challengesBoutique" */ "@/components/pages/sub_category/challenges/ChallengesBoutique"),   
                          meta: { 
                            bodyClass: 'challenges', 
                          }                           
                        },
                        {
                          path: "classement",
                          name: "challenges-classement",
                          component: () =>
                          import(/* webpackChunkName: "challengesClassement" */ "@/components/pages/sub_category/challenges/ChallengesClassement"),   
                          meta: { 
                            bodyClass: 'challenges', 
                          }                           
                        },
                        {
                          path: "destinations",
                          name: "challenges-destinations",
                          component: () =>
                          import(/* webpackChunkName: "challengesDestinations" */ "@/components/pages/sub_category/challenges/ChallengesDestinations"),   
                          meta: { 
                            bodyClass: 'challenges', 
                          }                
                        },                             
                      ]                         
                    },
                                      
                  ]                     
            },                           
            {
              path: "objectifs/",
              // name: "objectives",
              component: () =>
                  import(/* webpackChunkName: "objectives" */ "@/components/pages/category/Objectives"),
                  children:[
                    {
                      path: "/",
                      name: "objective_home",
                      component: () =>
                      import(/* webpackChunkName: "objectiveHome" */ "@/components/pages/sub_category/objectives/ObjectiveHome"),   
                      meta: { 
                        bodyClass: 'objective', 
                      },                               
                    },                      
                    {
                      path: "vie/:link",
                      name: "objective_life",
                      component: () =>
                      import(/* webpackChunkName: "life" */ "@/components/pages/sub_category/templates/Life"),  
                      children:[
                        {
                          path: "/sub/:id",
                          name: "sublife", 
                          component: () =>
                          import(/* webpackChunkName: "life" */ "@/components/pages/sub_category/templates/Life"),                                                      
                        }
                      ]                                    
                    },
                    {
                      path: "dommages/:id",
                      name: "objective_damage",
                      // beforeEnter : SecureGuard,
                      component: () =>
                      import(/* webpackChunkName: "damage" */ "@/components/pages/sub_category/templates/Damage"),              
                    },
                    {
                      path: "qualite/:name",
                      name: "objective_quality",
                      // beforeEnter : SecureGuard,
                      component: () =>
                      import(/* webpackChunkName: "quality" */ "@/components/pages/sub_category/templates/Quality"),              
                    }
                  ]                    
            },
            {
              path: "commerciaux",
              name: "commercials",
              // beforeEnter : SecureGuard,
              component: () =>
                  import(/* webpackChunkName: "commercials" */ "@/components/pages/category/Commercials"),
                  children:[
                    {
                      path: "/",
                      name: "commercials_home",
                      component: () =>
                      import(/* webpackChunkName: "commercialsHome" */ "@/components/pages/sub_category/commercials/CommercialsHome"),   
                      meta: { 
                        bodyClass: 'commercials', 
                      },                               
                    },     
                  ]                  
            },                         
            {
              path: "Api",
              name: "Api",
              // beforeEnter : SecureGuard,
              component: () =>
                  import(/* webpackChunkName: "Api" */ "@/components/pages/Api"),
            },            
            ]
      },

    ], 
    scrollBehavior (to, from, savedPosition) {
      // console.info(savedPosition) // first attemp undefined and next  always {x: 0, y: 0} regardless previous position      
      if (savedPosition) {
        return savedPosition
      } else if (to.name == from.name) 
      {
        return
      }
      else {
        return { x: 0, y: 0 }
      }
    }
  });


  router.beforeEach((to, from, next) => {
      const body = document.querySelector('body');
      let el = document.querySelector('ion-content');
      el &&
      el.scrollTo(0, 0);

      if(to.meta.bodyClass){
        body.classList.add(to.meta.bodyClass);
      }
      next();
  });
